<template>
    <div>
        <CompassMenu
            trigger="click"
            placement="left-start"
            custom-class="doc-overview-context-menu"
        >
            <CompassIconButton icon="action" />
            <template #dropdown>
                <CompassMenuItem :label="$t.__('common.actions.edit')" @click="$emit('update')" />
                <CompassMenuItem :label="$t.__('common.actions.unlink')" @click="$emit('unlink')" />
            </template>
        </CompassMenu>
    </div>
</template>

<script>
export default {
    name: 'ContextMenu',
};
</script>

<style>
#compass-menu-container .doc-overview-context-menu {
    width: 200px !important;
    z-index: 4 !important;
}

.doc-overview-context-menu .compass-icon {
    cursor: pointer;
}
</style>
